import * as Yup from 'yup';
export const AddSchema = Yup.object().shape({
  name: Yup.string().required('نام و نام خانوادگی  اجباری می باشد'),
  state: Yup.string().required('استان اجباری می باشد'),
  city: Yup.string(),
  email_address: Yup.string().email('ایمیل وارد شده اشتباه است '),
  phone_number: Yup.string()
    .matches(/^[0-9]+$/, 'شماره تلفن را به درستی وارد نمایید')
    .required('تلفن اجباری می باشد'),
});
